import * as types from './types';
const initialState = {
    list: [],
    autoDeleteTime: 10000,
};
export default function toastsReducer(state = initialState, unknownAction) {
    const action = unknownAction;
    switch (action.type) {
        case types.ADD_TOAST:
            return Object.assign(Object.assign({}, state), { list: [...state.list, action.payload] });
        case types.REMOVE_TOAST:
            return Object.assign(Object.assign({}, state), { list: state.list.filter((item) => item.id !== action.payload) });
        default:
            return state;
    }
}
